export const HttpStatusCode = {
    TooManyRequests: 429,
} as const;
